import { HttpMethod } from "../common/lib/fetch/useFetch";
import { RequestOptions } from "../common/lib/fetch/useRequest";
import useUserRequest from "../common/lib/fetch/useUserRequest";
import { useUser } from "../userAccess/useUser";

const useUnsuspendDriver = (id: string, options?: RequestOptions<void>) => {
  const user = useUser();

  return useUserRequest<void, void>({
    method: HttpMethod.POST,
    path: `/api/sites/${user.selectedSite?.id}/suspendedDrivers/${id}/unsuspend`,
  }, options);
}

export default useUnsuspendDriver;
